<template>
  <div class="">
    <div class="card">

      <img
          class="card-img-top"
          :alt="alt"
          :src="image"
      />

      <div class="card-body px-1">
        <slot>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A amet aperiam autem, eligendi est fugit iste
          iusto minima modi nesciunt numquam officia porro, quidem ut voluptates. Dolorem natus pariatur sint.
        </slot>
      </div>

    </div>
  </div>
</template>

<script>
import {CardProps} from "./CardProps";
export default {
  name: "Card3",
  props: {
    ...CardProps
  }
}
</script>


<style scoped>
.card-body {
  padding: 0px 0px 5px 0;
  text-align: center;
  direction: rtl;
}

.card {
  min-height: 390px;
  max-height: max-content;
  border-radius: 10px;
  margin: 0 10px 0 0;
}

.card-img-top {
  height: 200px;
  border-radius: 10px;
  object-fit: contain;
}

</style>